import {
  SAVE_ADVANCED_SEARCH_CRITERIA,
  SAVE_ADVANCED_SEARCH_SEARCH_CRITERIA,
  SAVE_ADVANCED_SEARCH_GRID_CRITERIA
} from 'actions';

// eslint-disable-next-line default-param-last
function advancedSearch(state = {
  searchCriteria: null,
  gridCriteria: null
}, action) {
  switch (action.type) {
    case SAVE_ADVANCED_SEARCH_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: action.searchCriteria
      };
    case SAVE_ADVANCED_SEARCH_GRID_CRITERIA:
      return {
        ...state,
        gridCriteria: action.gridCriteria
      };
    case SAVE_ADVANCED_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: action.searchCriteria,
        gridCriteria: action.gridCriteria
      };
    default:
      return state;
  }
}

export default advancedSearch;
